import React from "react";
import { useEffect, useState } from "react";
import "./EqStudentDashboard.scss";
import { notification, Spin } from "antd-v5";
import { Row, Col } from "antd";
import { useTranslation } from "react-i18next";

import Api from "../../shared/Api";
import {
    CourseOrderType,
    EqDisciplineType,
    EqEventUserType,
    eqNotificationTypes,
    EqTrainingType,
} from "../../shared/enums";
import { ApiEndpoints, GetEventMessage, openNotificationWithIcon, ValidateStudentCanBook, ValidateStudentCanPay } from "../../shared/Common";
import { IEqEventData, IEqUiEventInvite, IEqUiProfile } from "../../shared/interfaces/IEqEventDto";
import EqButton from "../../custom/eqButton/EqButton";
import { ISelectProps } from "../../shared/Interfaces";
import moment from "moment";
import AnimationDiv from "../../custom/animationDiv/AnimationDiv";
import { ExclamationCircleOutlined } from "@ant-design/icons";
//import upcomingTrainings from "../StudentUpcomingTraining/StudentUpcomingTraining";
import UpcommingActivity from "../Studentupcomingactivity/StudentUpcomingAct";

import {
    CourseLessonOrderEnt,
    EqEntityEventUserGroup,
    StudentUnpaidOrdersInfoDto,
} from "../../shared/general/IStudentUnpaidOrders";
import EqStudentSchedule from "../eqStudentSchedule/EqStudentSchedule";
// import InvitationCard from "../EqStudentInvitaion/EqstudentInvitations";
import { CourseUI, EqUiEvent } from "../../shared/interfaces/ridingCourse/IRidingCourse";
import modal from "antd-v5/es/modal";
import { useLocation } from "react-router-dom";
import { useAuthState } from "../../context/Context";
import UpcomingActDashboard from "../UpcomingActDashboard/UpcomingActDashboard";
import { EqEntityHorse } from "../../shared/interfaces/horse/IHorses";
import { IEventUserGroupDto } from "../../shared/interfaces/IEventUserGroupDto";
import { ITrainingInfoDto } from "../../shared/interfaces/ITrainingInfoDtos";
import { EqEntityTrainerStudent } from "../../shared/interfaces/IUserInfoDto";
import { IUpcomingActivitiesResultDto } from "../../shared/interfaces/schoolTraining/school";
import EqstudentInvitations from "../EqstudentInvitations/EqstudentInvitations";
import EqStudentCalendar from "../../custom/eqStudentCalendar/EqStudentCalendar";
import UnPaidOrdersModalStudent from "../UnPaidOrdersModalStudent/UnPaidOrdersModalStudent";
// interface HorseList{

interface UpcomingTraining {
    id: number;
    Title: string;
    Type: string;
    Trainer: string;
    startDate: string;
    Time: string;
    Location: string;
}

interface CourseInvitation {
    id: string;
    courseTitle: string;
    senderEmail: string;
    senderImage: string;
    pendingInvitations: number;
}
interface HorseList {
    id: string;
    activityType: string;
    date: string;
    time: string;
    Imageurl: string;
}
interface ProductInvitation {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    numberOfProducts: number;
    imageUrl: string;
}

const EqStudentDashboard = (props: any) => {
    const [unpaidOrders, setUnpaidOrders] = React.useState<StudentUnpaidOrdersInfoDto>();
    const [coursePendingInvites, setCoursePendingInvites] = React.useState<CourseLessonOrderEnt[]>([]);
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const userDetails: any = useAuthState();
    const { t } = useTranslation();
    const [messageString, setMessageString] = useState("");
    const [isError, setIsError] = React.useState(false);

    const [trainings, setTrainings] = React.useState<EqUiEvent[]| null>(null);
    const [events, setEvents] = React.useState<IEqEventData[]>([]); //Array<IEqEventData>
    const [studentEventClasses, setStudentEventClasses] = React.useState<IEventUserGroupDto[]>([]); //Array<IEqEventData>
    const [studentCourses, setStudentCourses] = React.useState<null | CourseUI[]>(null);
    const [studentProductOrders, setStudentProductsOrders] = React.useState([] as Array<any>); //Array<IEqEventData>
    
    const [pendingTrainingInvites, setPendingTrainingInvites] = React.useState<any[]>([]);
    //Not using
    const [subscribedTrainersList, setSubscribedTrainersList] = useState([]);
    const [subscribedSchoolsList, setSubscribedSchoolsList] = useState([]);
    const [message, setMessage] = React.useState("");
    const [productInvitations, setProductInvitations] = useState<ProductInvitation[]>([]);
    const [pendingInvites, setPendingInvites] = React.useState<IEqUiEventInvite[]>([]);
    const location = useLocation();
    const studentCanBook: boolean = ValidateStudentCanBook(userDetails);
    const studentCanPay: boolean = ValidateStudentCanPay(userDetails);

    //no use
    const [joinedTrainings, setJoinedTrainings] = React.useState(null) as any;
    const [stateView, setStateView] = useState({
        totalProfessionals: [],
        unpaidTraining: [],
        unpaidProduct: [],
        upcomingTraining: [],
    });
    //filter
    const [selectedTraining, setSelectedTraining] = React.useState<ITrainingInfoDto[]>([]);
    const [trainingOptions, setTrainingOptions] = React.useState<any[]>([]);
    const [horsesList, setHorsesList] = React.useState<EqEntityHorse[]>([])
    const [schoolPendingInvites, setSchoolPendingInvites] = React.useState<IEqUiProfile[]>([]);
    const [TrainerPendingInvites, SetTrainerPendingInvites] = React.useState<EqEntityTrainerStudent[]>([]);
    const [upcomingTrainingLessons, setUpcomingTrainingLessons] = React.useState<IUpcomingActivitiesResultDto[]>([])

    const [fromDate, setFromDate] = useState<moment.Moment | null>(null);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const GetCourseOrderCheckoutSession = async (orderId: any) => {
        try {
            let path = "api/CoursePayment/GetCourseOrderCheckoutSession" + `/${orderId}`;
            const response = await Api.get(path);
            if (response && response.status === 200) {
                window.location.href = response.headers.location;
            }
        } catch (error: any) {
            if (error.response.status === 409) {
                openNotificationWithIcon("Error!", error.response.data, eqNotificationTypes.error);
            } else {
                openNotificationWithIcon(t("serverError"), t("generalServerError"));
                console.error("Error Buy Course:", error);
            }
        }
    };

    const GetCourseLessonOrderCheckoutSession = async (orderId: any) => {
        try {
            let path = "api/CoursePayment/GetCourseLessonOrderCheckoutSession" + `/${orderId}`;
            // Replace with your API endpoint and method
            const response = await Api.get(path);
            if (response && response.status === 200) {
                window.location.href = response.headers.location;
            }
            // Optionally handle the result
        } catch (error: any) {
            if (error.response.status === 409) {
                // already exist
                openNotificationWithIcon("Error!", error.response.data, eqNotificationTypes.error);
                // setIsEventSubscribed(false);
            } else {
                openNotificationWithIcon(t("serverError"), t("generalServerError"));
                console.error("Error Buy Course:", error);
            }
        }
    };

    const AcceptInvite = async (orderInvite: CourseLessonOrderEnt) => {
        try {
            const response = await Api.put(
                `${ApiEndpoints.CourseOrderInvite.Accept}/${orderInvite.id}`
            );
            if (response.status === 200) {
                setCoursePendingInvites((prev: any) =>
                    prev.filter((invite: any) => invite.id !== orderInvite.id)
                );
                if (orderInvite.orderType === CourseOrderType.FullCourse) {
                    await GetCourseOrderCheckoutSession(orderInvite.id);
                } else {
                    await GetCourseLessonOrderCheckoutSession(orderInvite.id);
                }
                console.log("Accepted Successfully");
            }
        } catch (error: any) {
            handleApiError(error, t("acceptInviteError"));
        }
    };

    const CreateTrainingLessonOrderCheckoutSession = (event: any) => {
        var eventKey = event?.key;
        Api.post(ApiEndpoints.StudentTrainingStripeCheckout.Create, {
            key: eventKey,
        })
            .then((response) => {
                // console.log(response);
                window.location.href = response.data.sessionUrl;
            })
            .catch(() => {
                openNotificationWithIcon(
                    "Error!",
                    "Unable to Create checkout",
                    eqNotificationTypes.error
                );
            });
    };

    const GetAllStudentTrainers = () => {
        setMessageString("");

        Api.get(ApiEndpoints.GetStudentTrainers).then(
            (response) => {
                if (response && response.status == 200) {
                    // var pendingTrainingInvites = [] as any;
                    var data = response?.data ? response?.data : ([] as any);
                    setSubscribedTrainersList(data);
                    // if(data.length)
                    // {
                    //     onloadActivity(true);
                    // }
                    // else{
                    //     onloadActivity(false);

                    // }
                    //data.map((d: any, index: number) => {
                    //    pendingTrainingInvites.push(d);
                    //});
                } else {
                    setMessageString("Not found");
                }
            },
            () => {
                setMessageString("Not found");
            }
        );
    };
    const GetAllStudentSchools = () => {
        setMessageString("");

        Api.get(ApiEndpoints.GetStudentSchools).then(
            (response) => {
                if (response && response.status == 200) {
                    // var pendingTrainingInvites = [] as any;
                    var data = response?.data ? response?.data : ([] as any);
                    setSubscribedSchoolsList(data);
                } else {
                    setMessageString("Not found");
                }
            },
            () => {
                setMessageString("Not found");
            }
        );
    };
    const GetUserAcceptedEvents = () => {
        Api.get(ApiEndpoints.GetUserAcceptedEvents).then(
            (response) => {
                if (response && response.status == 200) {
                    var data = response.data ? [...response.data] : new Array<IEqEventData>();
                    data.map((f: any, index: number) => {
                        f.display = index == 0 ? true : false;
                    });
                    var event = data?.filter((opt: any) => opt.accessType == 2);
                    var trainings = data?.filter((opt: any) => opt.accessType == 1);

                    setEvents(event);
                    setTrainings(trainings);
                } else {
                    setIsError(true);
                }
            },
            () => {
                setIsError(true);
            }
        );
    };
    // This Api Call I need to change for Events
    const GetStudentJoinedEventClasses = () => {
        Api.get(ApiEndpoints.GetStudentJoinedClasses).then(
            (response) => {
                if (response && response.status == 200) {
                    var data = response.data ? [...response.data] : new Array<any>();
                    data.map((f: any, index: number) => {
                        f.display = index == 0 ? true : false;
                    });
                    setStudentEventClasses(data);
                } else {
                    setIsError(true);
                }
            },
            () => {
                setIsError(true);
            }
        );
    };

    const fetchStudentAllJoinedClasses = async () => {
        try {
            const response = await Api.get(
                ApiEndpoints.EqStudentPublicEvent.GetAllJoinedPublicEvents
            );
            if (response.status === 200) setStudentEventClasses(response.data);
        } catch (error: any) {
            console.error("API error:", error.response?.data || error.toJSON?.() || error.message);
        }
    };
    const fetchStudentAllJoinedCourses = async () => {
        try {
            const response = await Api.get(ApiEndpoints.StudentCourse.GetAllJoinedCourse);

            if (response.status === 200) setStudentCourses(response.data);
        } catch (error: any) {
            console.error("API error:", error.response?.data || error.toJSON?.() || error.message);
        }
    };

    const GetStudentProductOrders = () => {
        Api.get(ApiEndpoints.ProductOrder).then(
            (response) => {
                if (response && response.status == 200) {
                    var data = response.data ? [...response.data] : new Array<any>();

                    if (data.length > 0) {
                        var joinedProducts = data?.filter(
                            (opt: any) => opt.status == 1 || opt.status == 3
                        );

                        setStudentProductsOrders(joinedProducts);
                    }
                } else {
                    setIsError(true);
                }
            },
            (error) => {
                setIsError(true);
            }
        );
    };

    const GetAllPendingStudentCourseOrderInvites = async () => {
        try {
            const response = await Api.get(ApiEndpoints.CourseOrderInvite.GetAll);
            if (response?.status === 200) {
                const data: any = response.data || [];
                //const transformedData = transformApiResponseToCourseInvitations(data);
                setCoursePendingInvites(data);
            }
        } catch (error: any) {
            console.log("Failed to fetch invitations:", error);
        }
    };
    const GetAllPendingStudentProductOrderInvites = async () => {
        try {
            const response = await Api.get(ApiEndpoints.ProductOrderStudentInvites);
            if (response?.status === 200) {
                const data: any = response.data || [];
                //const transformedData = transformApiResponseToProductInvitations(data);
                setProductInvitations(data);
            }
        } catch (error: any) {
            console.log("Failed to fetch product invitations:", error);
        }
    };
    const getHorseList = () => {
        Api.get(ApiEndpoints.GetAllHorses).then(
            (response) => {
                if (response && response.status === 200) {
                    setIsError(false);
                    setMessage("");
                    let data = response.data;
                    if (data) {
                        data.forEach((obj: any) => {
                            obj.selected = false;
                        });

                        setHorsesList(data);
                    }
                } else {
                    setIsError(true);
                    setMessage(GetEventMessage(response.status));
                }
            },
            (error: any) => {
                setIsError(true);
                setMessage(GetEventMessage(error.response.status));
            }
        );
    };
    const transformData = (data: any[]): HorseList[] => {
        const activities: HorseList[] = [];

        const formatDate = (dateString: string): any => {
            const date = new Date(dateString);
            return date.toLocaleDateString("en-GB", {
                day: "numeric",
                month: "long",
            });
        };
        const formatTime = (timeString: string): string => {
            const time = new Date(timeString);
            return time.toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            });
        };

        data.forEach((horse) => {
            horse.horseTasks.forEach((task: any) => {
                activities.push({
                    id: task.id,
                    activityType: "Task",
                    date: formatDate(task.date),
                    time: formatTime(task.time),
                    Imageurl: "ScheduleOutlined",
                });
            });
            horse.horseTrainings.forEach((training: any) => {
                activities.push({
                    id: training.id,
                    activityType: "Training",
                    date: formatDate(training.date),
                    time: formatTime(training.time),
                    Imageurl: "ContainerFilled",
                });
            });
        });

        return activities;
    };

    //const horseactivities = transformData(horsesList);

    //function transformApiResponseToTrainingList(apiData: any[]): UpcomingTraining[] {
    //    const formatDate = (dateString: string): string => {
    //        const date = new Date(dateString);
    //        const day = date.getDate();
    //        const month = date.toLocaleString('en-GB', { month: 'short' });
    //        const year = date.getFullYear().toString().slice(-2);
    //        return `${day}-${month}-${year}`;
    //    };

    //    const formatTime = (timeString: string): string => {
    //        const time = new Date(timeString);
    //        return time.toLocaleTimeString('en-GB', {
    //            hour: '2-digit',
    //            minute: '2-digit',
    //            hour12: false,
    //        });
    //    };

    //    return apiData.map((item, index) => {

    //      const trainers = item.organizers?.map((organizer: any) => (
    //                organizer.user.firstName +" "+ organizer.user.lastName
    //        ))
    //        const trainingTime = new Date(item.startTime);
    //        return {
    //            id: item.id,
    //            Title: item.title,
    //            Type: getDisciplineType(item.disciplineType),
    //            Trainer: trainers,
    //            startDate: formatDate(item.startDate),
    //            Time: trainingTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
    //            Location: location,
    //        };
    //    });
    //}
    //function getDisciplineType(disciplineType: number): string {
    //    switch (disciplineType) {
    //        case 1:
    //            return "Private Lesson";
    //        case 2:
    //            return "Group Lesson";
    //        case 3:
    //            return "Available Time Slot";
    //        case 4:
    //            return "Riding Course";
    //        default:
    //            return "Unknown";
    //    }
    //}

    const AcceptTrainerInvite = async (e: string) => {
        try {
            const response = await Api.post(ApiEndpoints.AcceptTrainerInvite, { key: e });

            if (response.status === 200) {
                SetTrainerPendingInvites((prev: any) =>
                    prev.filter((invite: any) => invite.key !== e)
                );
                console.log("Successfully accepted trainer invite", e);
            } else {
                console.error("Error accepting trainer invite:", response.status, response.data);
            }
        } catch (error: any) {
            console.error("API error:", error.response?.data || error.toJSON?.() || error.message);
        }
    };

    const RejectTrainerInvite = async (e: string) => {
        try {
            const response = await Api.post(ApiEndpoints.RejectTrainerInvite, { key: e });

            if (response.status === 200) {
                SetTrainerPendingInvites((prev: any) =>
                    prev.filter((invite: any) => invite.key !== e)
                );
                console.log("Successfully rejected trainer invite", e);
            } else {
                console.error("Error rejecting trainer invite:", response.status, response.data);
            }
        } catch (error: any) {
            console.error("API error:", error.response?.data || error.toJSON?.() || error.message);
        }
    };

    const confirmTrainerPayment = (trainer: any) => {
        modal.confirm({
            width: 1000,
            title: "Terms And Conditions",
            icon: <ExclamationCircleOutlined />,
            content: (
                <p style={{ whiteSpace: "pre-wrap" }}>
                    <div dangerouslySetInnerHTML={{ __html: trainer?.trainerTerms }} />
                </p>
            ),
            okText: "Accept",
            onOk: () => AcceptTrainerInvite(trainer.key),
        });
    };

    const onAcceptTrainer = (trainer: any) => {
        confirmTrainerPayment(trainer);
        console.log("The Trainer is accepted successfully,", trainer);
    };

    const onRejectTrainer = (trainer: any) => {
        RejectTrainerInvite(trainer.key);
        console.log("The Trainer is Rejected Successfully", trainer);
    };

    const transformApiResponseToProductInvitations = (apiResponse: any[]): ProductInvitation[] => {
        const userProductCountMap: { [key: string]: number } = {};
        apiResponse.forEach((item) => {
            const userEmail = item.product?.user?.email || "Unknown";
            userProductCountMap[userEmail] = (userProductCountMap[userEmail] || 0) + 1;
        });
        return apiResponse.map((item) => ({
            id: item.id,
            firstName: item.product?.user?.firstName || "Unknown",
            lastName: item.product?.user?.lastName || "Unknown",
            email: item.product?.user?.email || "Unknown",
            numberOfProducts: userProductCountMap[item.product?.user?.email] || 0,
            imageUrl: item.product?.imageUrl || "",
        }));
    };

    const dashboardState = () => {
        Api.get(ApiEndpoints.GetStudentDashboardState)
            .then((response) => {
                if (response && response.status === 200) {
                    const {
                        totalProfessionals,
                        unPaidProductOrders,
                        unPaidTrainingOrders,
                        upcomingTrainings,
                    } = response.data;
                    setStateView({
                        totalProfessionals: totalProfessionals,
                        unpaidTraining: unPaidTrainingOrders,
                        unpaidProduct: unPaidProductOrders,
                        upcomingTraining: upcomingTrainings,
                    });
                } else {
                    setIsError(true);
                    GetEventMessage(response.status);
                }
            })
            .catch((error) => {
                GetEventMessage(error.response.status);
            });
    };

    const GetAllTrainingJoinInvitesForStudents = async () => {
        setMessageString("");

        try {
            const response = await Api.get(ApiEndpoints.StudentTrainingInvite.GetAllPending);

            if (response && response.status === 200) {
                const data = response?.data ? response.data : [];
                setPendingTrainingInvites(response.data);
            }
        } catch (err) {
            console.error("Error fetching pending training invites:", err);
        }
    };

    const studentJoinedLessons = () => {
        Api.get(ApiEndpoints.StudentAllJoinedLessons)
            .then((response) => {
                if (response && response.status === 200) {
                    var data = response.data;
                    setJoinedTrainings(data);
                    //    console.log("training", data);
                } else {
                    setIsError(true);
                    GetEventMessage(response.status);
                }
            })
            .catch((error) => {
                GetEventMessage(error.response.status);
            });
    };

    const filterTrainings = (trainingList: any[]) => {
        let filteredList = trainingList;
        if (selectedTraining && selectedTraining.length > 0) {
            filteredList = filteredList.filter((item) => {
                return selectedTraining.some(
                    (selectedType: any) => item?.event.disciplineType === selectedType
                );
            });
        }

        if (fromDate) {
            const FromDate = moment(fromDate).startOf("day").valueOf();
            filteredList = filteredList.filter((item) => {
                const startDate = moment(item?.event.startDate).startOf("day").valueOf();
                return startDate === FromDate;
            });
        }

        return filteredList;
    };
    const trainingTypeProps: ISelectProps = {
        classNames: `eq-multiSelect eq-searchSelect`,
        placeholder: t("training"),
        extraHeight: true,
        mode: "multiple",
        isTag: false,
        defaultSelectedValue: selectedTraining ? selectedTraining : [],
        options: trainingOptions,
        changeFunc: (value: any) => {
            setSelectedTraining(value);
        },
    };
    const createTrainingList = () => {
        var eventTypes = [];
        eventTypes.push({
            key: EqDisciplineType.Dressage,
            value: EqTrainingType[EqTrainingType.PrivateLesson],
        });
        eventTypes.push({
            key: EqDisciplineType.Jumping,
            value: EqTrainingType[EqTrainingType.GroupLesson],
        });
        eventTypes.push({
            key: EqDisciplineType.Open,
            value: EqTrainingType[EqTrainingType.AvailableTimeSlots],
        });
        eventTypes.push({
            key: EqDisciplineType.RidingCourse,
            value: EqDisciplineType[EqDisciplineType.RidingCourse],
        });
        setTrainingOptions(eventTypes);
    };

    const fetchOrders = async () => {
        setLoading(true);
        try {
            const response = await Api.get(`${ApiEndpoints.Student.GetUnpaidOrders}`);
            let data = response.data as StudentUnpaidOrdersInfoDto;

            setUnpaidOrders(data);
            if (
                data.unPaidTrainingOrders.length > 0 ||
                data.unPaidCourseOrders.length > 0 ||
                data.unPaidCourseLessonOrders.length > 0
            ) {
                showModal();
            }
        } catch (error) {
            console.error("fetchOrders", error);
        } finally {
            setLoading(false);
        }
    };
    const showModal = () => setIsModalVisible(true);
    const handleCancel = () => setIsModalVisible(false);

    const checkClosable = (): boolean => {
        const today = moment().startOf("day");
        if (unpaidOrders?.unPaidCourseOrders && unpaidOrders.unPaidCourseOrders.length > 0) {
            return false;
        } else if (
            unpaidOrders?.unPaidCourseLessonOrders &&
            unpaidOrders.unPaidCourseLessonOrders.length > 0
        ) {
            return false;
        } else if (unpaidOrders?.unPaidTrainingOrders) {
            return unpaidOrders.unPaidTrainingOrders.every((order) => {
                const organizer = order?.event?.organizers?.find(
                    (org) => org.eventUserType === EqEventUserType.Owner
                )?.user;
                // const organizer = order.event.organizers.find((org:any) => org.allowLatePayments);
                if (!organizer) return true; // Closable remains true if no organizer allows late payments
                if (!organizer.allowLatePayments) return false;

                const paymentDeadline = moment(order?.event?.startTime).add(
                    organizer.paymentDays ?? 0,
                    "days"
                );
                return paymentDeadline.isSameOrAfter(today); // Closable if within the payment window
            });
        } else {
            return true;
        }
    };

    //const GetUpcomingTrainingsLessons = async () => {
    //    try {

    //        const params ={
    //            skipCount: 0,
    //            maxResultCount: 10
    //        };
    //      const response = await Api.get(ApiEndpoints.StudentTraining.GetUpcomingTrainingsLessons, { params });

    //      setUpcomingTrainingLessons(response.data);

    //    //   return response.data; // Return response data
    //    } catch (error) {
    //      console.error("Error fetching upcoming trainings:", error);
    //      throw error; // Rethrow error for handling in the component
    //    }
    //}
    const StudentGetUpcomingActivities = async () => {
        try {
            const response = await Api.get(ApiEndpoints.StudentGetUpcomingActivities);

            setUpcomingTrainingLessons(response.data);
            //console.log("The response recieved from the New Api is", response.data);

            //   return response.data; // Return response data
        } catch (error) {
            console.error("Error fetching upcoming trainings:", error);
            throw error; // Rethrow error for handling in the component
        }
    };

    const GetAllPendingSchoolInvites = () => {
        setMessageString("");
        Api.get(ApiEndpoints.StudentSchoolGetAllPendingInvites).then(
            (response) => {
                if (response && response.status === 200) {
                    var data = response?.data ? response?.data : ([] as any);
                    setSchoolPendingInvites(data);
                    console.log("The School ending invitations are", response.data);
                } else {
                    setMessageString("Not found");
                }
            },
            (err) => {
                setMessageString("Not found");
            }
        );
    };

    //const GetAllPendingSchoolInvites = async () => {
    //    try {
    //        const response = await Api.get(ApiEndpoints.StudentSchoolGetAllPendingInvites);

    //        if (response.status === 200 && response.data) {
    //            setSchoolPendingInvites(response.data);
    //            console.log("The School ending invitations are", response.data);
    //        } else {
    //            console.error("Error fetching pending invites:", response.status, response.data);
    //        }

    //    } catch (error: any) {
    //        console.error("API error:", error.response?.data || error.toJSON?.() || error.message);
    //    }
    //};

    const GetAllPendingTrainerInvites = async () => {
        try {
            const response = await Api.get(ApiEndpoints.GetAllPendingTrainerInvites);

            if (response.status === 200 && response.data) {
                SetTrainerPendingInvites(response.data);
            } else {
                console.error("Error fetching pending invites:", response.status, response.data);
            }
        } catch (error: any) {
            console.error("API error:", error.response?.data || error.toJSON?.() || error.message);
        }
    };

    // const GetAllPendingTrainerInvites = () => {
    //     setMessageString("");
    //     Api.get(ApiEndpoints.GetAllPendingTrainerInvites).then(
    //         (response) => {
    //             if (response && response.status == 200) {
    //                 // var pendingTrainingInvites = [] as any;
    //                 var data = response?.data ? response?.data : ([] as any);
    //                 SetTrainerPendingInvites(data);
    //             } else {
    //                 setMessageString("Not found");
    //             }
    //         },
    //         () => {
    //             setMessageString("Not found");
    //         }
    //     );
    // };
    const handleApiError = (error: any, defaultMessage: string) => {
        const errorMessage = error?.response?.data || defaultMessage;
        openNotificationWithIcon(t("error"), t(errorMessage), eqNotificationTypes.error);
        console.error(errorMessage);
    };

    const RejectCourseInvite = async (orderInvite: any) => {
        try {
            const response = await Api.put(
                `${ApiEndpoints.CourseOrderInvite.Reject}/${orderInvite.id}`
            );
            if (response.status === 200) {
                setCoursePendingInvites((prev: any) =>
                    prev.filter((invite: any) => invite.id !== orderInvite.id)
                );
            }
        } catch (error: any) {
            handleApiError(error, t("rejectInviteError"));
        }
    };
    function RejectProductOrderInvite(e: any) {
        if (!e || !e.id) {
            console.error("Invalid invitation object:", e);
            return;
        }
        console.log("It is actually called");
        Api.put(ApiEndpoints.ProductOrderReject + e.productId).then(
            (response) => {
                if (response && response.status === 200) {
                    setProductInvitations((prev) =>
                        prev.filter((invite: any) => invite.id !== e.id)
                    );
                    //console.log("The data is", response.data);
                } else {
                    setMessageString("");
                }
            },
            (err) => {
                console.error("Error rejecting product order:", err);
                setMessageString("");
            }
        );
    }

    const rejectProduct = (productOrder: any) => {
        RejectProductOrderInvite(productOrder);
        // setSteps(5);
    };
    const AcceeptProductClick = (productOrder: any) => {
        // if (studentCanBook) {

        const isLateAllowed = productOrder?.product?.user.allowLatePayments || false;

        if (isLateAllowed) {
            AcceptProductOrderInvite(productOrder);
        } else {
            // checkout
            CreateCheckoutSession(productOrder.id);
        }
        // } else {
        //     openNotificationWithIcon(
        //         "Error!",
        //         "you don't have permission, contact Admin",
        //         // "Add Parent to buy",
        //         eqNotificationTypes.error
        //     );
        // }
    };
    const AcceptProductOrderInvite = async (e: any) => {
        try {
            const response = await Api.put(`${ApiEndpoints.ProductOrderAccept}${e.id}`);

            if (response.status === 200) {
                console.log("Successfully accepted product order invite:", e.id);
                GetAllPendingStudentProductOrderInvites();
                openCheckOutNotificationProduct(
                    "Accepted!",
                    "Pay for the accepted order request",
                    e.id
                );
            } else {
                console.error("Unexpected response:", response.status, response.data);
                setMessageString("Failed to accept the order invite.");
            }
        } catch (error: any) {
            if (error.response?.status === 409) {
                console.warn(`Conflict: Product ${error.response.data.product?.title} is full.`);
                openNotificationWithIcon(
                    "Conflict",
                    `Product ${error.response.data.product?.title} is full and cannot be accepted now.`
                );
                GetAllPendingStudentProductOrderInvites();
            } else {
                console.error(
                    "API error:",
                    error.response?.data || error.toJSON?.() || error.message
                );
                openNotificationWithIcon(
                    "Server error",
                    "An error occurred while processing the product order. Please try again or contact the administrator."
                );
            }
        }
    };

    const openCheckOutNotificationProduct = (msg: any, desc: any, orderId: any) => {
        const btn = (
            <div className="right">
                <EqButton onClick={() => CreateCheckoutSession(orderId)}>Pay Now</EqButton>
            </div>
        );
        notification["info"]({
            message: msg,
            btn,
            description: desc,
        });
    };

    // const CreateCheckoutSession = (orderId: any) => {

    //     Api.get(
    //         ApiEndpoints.ProductPayment.GetProductOrderCheckoutSession + `/${orderId}`
    //     )
    //         .then((response) => {
    //             window.location.href = response.data.sessionUrl;
    //         })
    //         .catch((error) => {
    //             openNotificationWithIcon(
    //                 "Error!",
    //                 "Unable to Create checkout Session",
    //                 eqNotificationTypes.error
    //             );
    //         });
    // };

    const CreateCheckoutSession = async (orderId: any) => {
        try {
            const response = await Api.get(
                `${ApiEndpoints.ProductPayment.GetProductOrderCheckoutSession}/${orderId}`
            );

            if (response.status === 200 && response.data?.sessionUrl) {
                console.log("Redirecting to checkout session:", response.data.sessionUrl);
                window.location.href = response.data.sessionUrl;
            } else {
                console.error("Unexpected response:", response.status, response.data);
                openNotificationWithIcon(
                    "Error!",
                    "Failed to create checkout session. Please try again.",
                    eqNotificationTypes.error
                );
            }
        } catch (error: any) {
            console.error("API error:", error.response?.data || error.message);
            let message = t(error.response?.data) || t("generalServerError");
            openNotificationWithIcon(t("serverError"), message, eqNotificationTypes.error);
        }
    };

    const AcceptSchoolInvite = async (e: string) => {
        try {
            const response = await Api.post(ApiEndpoints.StudentSchoolAcceptInvite, { key: e });

            if (response.status === 200) {
                setSchoolPendingInvites((prev: any) =>
                    prev.filter((invite: any) => invite.key !== e)
                );
                console.log("Successfully accepted school invite", e);
            } else {
                console.error("Error accepting school invite:", response.status, response.data);
            }
        } catch (error: any) {
            console.error("API error:", error.response?.data || error.toJSON?.() || error.message);
        }
    };

    const RejectSchoolInvite = async (e: string) => {
        try {
            const response = await Api.post(ApiEndpoints.StudentSchoolRejectInvite, { key: e });

            if (response.status === 200) {
                setSchoolPendingInvites((prev: any) =>
                    prev.filter((invite: any) => invite.key !== e)
                );
                console.log("Successfully rejected school invite", e);
            } else {
                console.error("Error rejecting school invite:", response.status, response.data);
            }
        } catch (error: any) {
            console.error("API error:", error.response?.data || error.toJSON?.() || error.message);
        }
    };

    const confirmSchoolTerms = (school: any) => {
        modal.confirm({
            title: "School Terms",
            width: 1000,
            icon: <ExclamationCircleOutlined />,

            content: (
                <p style={{ whiteSpace: "pre-wrap" }}>
                    {" "}
                    <div dangerouslySetInnerHTML={{ __html: school?.trainerTerms }} />
                </p>
            ),
            okText: "Accept",
            onOk: () => AcceptSchoolInvite(school.key),
        });
    };
    const handleOnAcceptSchoolInvite = (school: any) => {
        confirmSchoolTerms(school);
        console.log("I am inside accepted Clicked Function", school);
    };

    const handleOnRejectSchoolInvite = (e: any) => {
        RejectSchoolInvite(e.key);
        console.log("I am inside rejected Clicked Function", e);
    };
    //const removeProductFromList = (product:any) => {
    //    const updatedList = productInvitations.filter((item) => item.id !== product.id);
    //    setProductInvitations(updatedList);
    //    console.log("Updated Product Invitations List:", updatedList);
    //};
    const CreateCheckoutSessionforTraining = (event: any) => {
        var eventKey = event?.key;
        Api.post(ApiEndpoints.StudentTrainingStripeCheckout.Create, {
            key: eventKey,
        })
            .then((response) => {
                console.log(response);
                window.location.href = response.data.sessionUrl;
            })
            .catch((error) => {
                openNotificationWithIcon(
                    "Error!",
                    "Unable to Create checkout",
                    eqNotificationTypes.error
                );
            });
    };
    const AcceptTrainingInvitation = (eventOrder: any) => {
        if (studentCanBook) {
            const isLateAllowed = isLatePaymentAllowed(eventOrder.event);
            if (isLateAllowed) {
                AcceptEventInvite(eventOrder);
            } else {
                CreateCheckoutSessionforTraining(eventOrder.event);
            }
            console.log(eventOrder);
        } else {
            openNotificationWithIcon(
                "Error!",
                "you don't have permission, contact Admin",
                eqNotificationTypes.error
            );
        }
        console.log(eventOrder);
    };
    function AcceptEventInvite(e: any) {
        Api.post(ApiEndpoints.StudentTrainingInvite.AcceptEventInvite, {
            key: e.eventKey,
        }).then(
            (response) => {
                if (response && response.status == 202) {
                    GetAllTrainingJoinInvitesForStudents();
                    if (studentCanPay) {
                        openNotificationCheckOutNotification(
                            "Pay for the accepted Activity",
                            "",
                            e.event
                        );
                    }
                } else if (response && response.status == 200) {
                    GetAllTrainingJoinInvitesForStudents();
                    openNotificationWithIcon(
                        "Accepted! ",
                        "Invite Accepted and Paid",
                        eqNotificationTypes.success
                    );
                } else {
                    setMessageString("");
                }
            },
            (err) => {
                setMessageString("");
            }
        );
    }
    const openNotificationCheckOutNotification = (msg: any, desc: any, event: any) => {
        const btn = (
            <div className="right">
                <EqButton onClick={() => CreateCheckoutSessionforTraining(event)}>Pay Now</EqButton>
            </div>
        );
        notification["info"]({
            message: msg,
            btn,
            description: desc,
        });
    };
    const isLatePaymentAllowed = (event: any) => {
        const ownerOrganizer = event.organizers.find(
            (organizer: any) => organizer.eventUserType === EqEventUserType.Owner
        );
        return ownerOrganizer?.user?.allowLatePayments || false;
    };

    const RejectTrainingInvite = (event: any) => {
        RejectedTrainingInvite(event.eventKey);
        console.log(event);
        // setSteps(5);
    };
    function RejectedTrainingInvite(e: any) {
        // e.stopPropagation();
        // setStatus("accept");
        Api.post(ApiEndpoints.StudentTrainingInvite.RejectEventInvite, {
            key: e,
        }).then(
            (response) => {
                if (response && response.status == 200) {
                    GetAllTrainingJoinInvitesForStudents();
                    //setSteps(1);
                } else {
                    setMessageString("");
                }
            },
            (err) => {
                setMessageString("");
            }
        );
    }

    useEffect(() => {
        // GetUpcomingTrainingsLessons()
        StudentGetUpcomingActivities();
        // GetAllTrainingLessonsByConnections();
        GetAllPendingSchoolInvites();
        GetAllPendingTrainerInvites();
        createTrainingList();
        GetUserAcceptedEvents();
        GetStudentProductOrders();
        GetAllPendingStudentProductOrderInvites();
        GetAllTrainingJoinInvitesForStudents();
        // GetStudentJoinedEventClasses();
        fetchStudentAllJoinedClasses();
        fetchStudentAllJoinedCourses();
        GetAllStudentTrainers();
        GetAllStudentSchools();
        dashboardState();
        studentJoinedLessons();
        getHorseList();
        fetchOrders();
        GetAllPendingStudentCourseOrderInvites();
        console.log("The list after the acceptance", schoolPendingInvites);
    }, []);
    return (
        <Spin size="large" spinning={loading} fullscreen={loading}>
            <AnimationDiv>
                <div className="eq-stb-container">
                    <Row className="eq-stb-heading-row">
                        <Col className="eq-stb-col" flex="auto" md={5} xs={24} sm={24}>
                            <h3 className="eq-stb-heading">{t("myDashboard")}</h3>
                        </Col>
                    </Row>

                    <Row className="Cards-div">
                        <div className="invitation-card-container">
                            <EqstudentInvitations
                                TrainingInvitratoin={pendingTrainingInvites}
                                Productinvitations={productInvitations}
                                SchoolPenInvitation={schoolPendingInvites}
                                TrainerPenInvitation={TrainerPendingInvites}
                                courseInvitation={coursePendingInvites}
                                onRejectCourseInvite={RejectCourseInvite}
                                onAcceptCourseInvite={AcceptInvite}
                                onRejectProduct={rejectProduct}
                                // onAcceptProduct={AcceeptProductClick}
                                onAcceptTrainingInvitations={AcceptTrainingInvitation}
                                onRejectTrainingInvite={RejectTrainingInvite}
                                onAcceptProductClick={AcceeptProductClick}
                                onAcceptTrainer={onAcceptTrainer}
                                onRejectTrainer={onRejectTrainer}
                                onAcceptSchoolInvite={handleOnAcceptSchoolInvite}
                                onRejectSchoolInvite={handleOnRejectSchoolInvite}
                            />
                        </div>
                        <div className="upcoming-activity-container">
                            <UpcommingActivity Activities={horsesList} />
                        </div>
                    </Row>
                    <UpcomingActDashboard
                        Trainings={upcomingTrainingLessons}
                        TrainingHeading={t("upcomingActivities")}
                        user="student"
                    />

                    <EqStudentCalendar
                        isOwner={false}
                        events={studentEventClasses}
                        trainings={trainings}
                        courses={studentCourses}
                        horsesList={horsesList}
                        selectFun={undefined}
                    />

                    {/* <EqStudentSchedule
          isOwner={false}
          isStudent={true}
          eventList={studentEventClasses}
          trainings={trainings}
          studentProductOrders={studentProductOrders}
          courses={studentCourses}
          horsesList={horsesList}
        
        ></EqStudentSchedule> */}

                    {/* <div className="eq-section">*/}
                    {/*  <Row className="eq-db-row" align="stretch">*/}
                    {/*    <Col flex="auto" className="eq-db-icons">*/}
                    {/*      <Row>*/}
                    {/*        <h5 className="eq-db-h2">{t("quickLinks")}</h5>*/}
                    {/*      </Row>*/}
                    {/*      <Row align="bottom" justify="start" className="eq-db-icon-row">*/}
                    {/*        <Col className="eq-db-icon" xs={8} sm={8} md={4}>*/}
                    {/*          <Link to={FrontEndPoints.student.allTrainings}>*/}
                    {/*            <span>*/}
                    {/*              <img alt="" src="/training.svg" />*/}
                    {/*            </span>*/}
                    {/*            <div className="eq-db-icon-text">{t("myTrainings")}</div>*/}
                    {/*          </Link>*/}
                    {/*        </Col>*/}
                    {/*      </Row>*/}
                    {/*    </Col>*/}
                    {/*  </Row>*/}
                    {/*</div> */}
                    {/*<div className="eq-section">*/}
                    {/*    <StudentOverViewProfile stat={stateView} joinedTraining={joinedTrainings} />*/}
                    {/*</div>*/}

                    {/* {subscribedTrainersList && subscribedTrainersList.length > 0 ? (
          <>
            <div className="eq-section-divider"></div>
            <div className="eq-section">
              <EqCollapsePanel
                defaultOpen={true}
                header={t("subscribedTrainers")}
                children={[...subscribedTrainersList].map(
                  (item: any, index: number) => (
                    <EqSubscribedTrainer
                      key={index}
                      trainer={item}
                    ></EqSubscribedTrainer>
                  )
                )}
              />
            </div>
          </>
        ) : (
          ""
        )} */}

                    {/* {subscribedSchoolsList && subscribedSchoolsList.length > 0 ? (
          <>
            <div className="eq-section-divider"></div>
            <div className="eq-section">
              <EqCollapsePanel
                defaultOpen={true}
                header={t("subscribedSchools")}
                children={[...subscribedSchoolsList].map(
                  (school: any, index: number) => (
                    <EqSubscribedUser
                      key={index}
                      user={school}
                    ></EqSubscribedUser>
                  )
                )}
              />
            </div>
          </>
        ) : (
          ""
        )} */}

                    {/*{courseInvitation ? (*/}
                    {/*    <>*/}
                    {/*        <div className="eq-section-divider"></div>*/}
                    {/*        <div className="eq-section">*/}
                    {/*            <EqCollapsePanel*/}
                    {/*                defaultOpen={true}*/}
                    {/*                header={t("Course Invitations")}*/}
                    {/*                children={*/}
                    {/*                    <EqCourseInviteSection*/}
                    {/*                        onloadActivity={(e: any) => {*/}
                    {/*                            setCourseInvitation(e);*/}
                    {/*                        }}*/}
                    {/*                    />*/}
                    {/*                }*/}
                    {/*            />*/}
                    {/*        </div>*/}
                    {/*    </>*/}
                    {/*) : (*/}
                    {/*    ""*/}
                    {/*)}*/}
                    {/* <Row className="Cards-div">
                        <div className="invitation-card-container">
                            <InvitationCard
                                TrainingInvitratoin={pendingInvites}
                                Productinvitations={productInvitations}
                                SchoolPenInvitation={schoolPendingInvites}
                                TrainerPenInvitation={TrainerPendingInvites}
                                courseInvitation={coursePendingInvites}
                                onRejectCourseInvite={RejectCourseInvite}
                                onAcceptCourseInvite={AcceptInvite}
                                onRejectProduct={rejectProduct}
                                onAcceptTrainingInvitations={AcceptTrainingInvitation}
                                onRejectTrainingInvite={RejectTrainingInvite }
                                onAcceptProductClick={AcceeptProductClick}
                                onAcceptTrainer={onAcceptTrainer}
                                onRejectTrainer={onRejectTrainer}
                                onAcceptSchoolInvite={handleOnAcceptSchoolInvite}
                                onRejectSchoolInvite={handleOnRejectSchoolInvite}
                             
                            />
                        </div>
                        <div className="upcoming-activity-container">
                            <UpcommingActivity
                                Activities={horsesList}
                            />
                        </div>
                    </Row> */}
                    {/*<UpcomingTrainingCard*/}
                    {/*    TrainingHeading={t("upcomingTrainings")} Trainings={upcomingTrainingLessons}*/}
                    {/*    onUpdate={()=>{GetUpcomingTrainingsLessons()}}*/}
                    {/*/>*/}

                    {/*{productOrderInvitation ? (*/}
                    {/*    <>*/}
                    {/*        <div className="eq-section-divider"></div>*/}
                    {/*        <div className="eq-section">*/}
                    {/*            <EqCollapsePanel*/}
                    {/*                defaultOpen={true}*/}
                    {/*                header={t("productOrderInvitations")}*/}
                    {/*                children={*/}
                    {/*                    <EqProductInvitationBoard*/}
                    {/*                        onloadActivity={(e: any) => {*/}
                    {/*                            setProductOrderInvitation(e);*/}
                    {/*                        }}*/}
                    {/*                    />*/}
                    {/*                }*/}
                    {/*            />*/}
                    {/*        </div>*/}
                    {/*    </>*/}
                    {/*) : (*/}
                    {/*    ""*/}
                    {/*)}*/}
                    {/*   {activityInvitation ? (
                        <>
                            <div className="eq-section-divider"></div>
                            <div className="eq-section">
                                <EqCollapsePanel
                                    defaultOpen={true}
                                    header={t("trainingInvitations")}
                                    children={
                                        <EqEventInvitationBoard
                                            onloadActivity={(e: any) => {
                                                setActivityInvitation(e);
                                            }}
                                        />
                                    }
                                />
                            </div>
                        </>
                    ) : (
                        ""
                    )} */}

                    {/*{acceptedRequests ? (*/}
                    {/*    <>*/}
                    {/*        <div className="eq-section-divider"></div>*/}
                    {/*        <div className="eq-section">*/}
                    {/*            <EqCollapsePanel*/}
                    {/*                defaultOpen={true}*/}
                    {/*                header={t("acceptedRequest")}*/}
                    {/*                children={*/}
                    {/*                    <EqAcceptedTrainingRequests*/}
                    {/*                        onloadActivity={(e: any) => {*/}
                    {/*                            setAcceptedRequests(e);*/}
                    {/*                        }}*/}
                    {/*                    />*/}
                    {/*                }*/}
                    {/*            />*/}
                    {/*        </div>*/}
                    {/*    </>*/}
                    {/*) : (*/}
                    {/*    ""*/}
                    {/*)}*/}

                    {/* <div className="eq-section">
          <Row className="eq-msg-header" align="bottom">
            <Col flex="auto">
              <div className="eq-db-h2"> Activity Invitations</div>
            </Col>
          </Row>

          <EqEventInvitationBoard />
        </div> */}

                    {/*{trainerInvitation ? (*/}
                    {/*    <>*/}
                    {/*        <div className="eq-section-divider"></div>*/}
                    {/*        <div className="eq-section">*/}
                    {/*            <EqCollapsePanel*/}
                    {/*                defaultOpen={true}*/}
                    {/*                header={t("trainerInvitations")}*/}
                    {/*                children={*/}
                    {/*                    <EqTrainerInvitationBoard*/}
                    {/*                        onloadActivity={(e: any) => {*/}
                    {/*                            setTrainerInvitation(e);*/}
                    {/*                        }}*/}
                    {/*                    />*/}
                    {/*                }*/}
                    {/*            />*/}
                    {/*        </div>*/}
                    {/*    </>*/}
                    {/*) : (*/}
                    {/*    ""*/}
                    {/*)}*/}

                    {/* {schoolInvitation ? (
                        <>
                            <div className="eq-section-divider"></div>
                            <div className="eq-section">
                                <EqCollapsePanel
                                    defaultOpen={true}
                                    header={t("schoolInvitations")}
                                    children={
                                        <EqSchoolInvitationBoard
                                            onloadActivity={(e: any) => {
                                                setSchoolInvitation(e);
                                            }}
                                        />
                                    }
                                />
                            </div>
                        </>
                    ) : (
                        ""
                    )} */}

                    {/*<div className="eq-section-divider"></div>*/}
                    {/*<div className="eq-section eq-section-training">*/}
                    {/*    <Skeleton loading={!joinedTrainings} active></Skeleton>*/}
                    {/*    <Row>*/}
                    {/*        {joinedTrainings && (*/}
                    {/*            <Col span={24}>*/}
                    {/*                <EqCollapsePanel*/}
                    {/*                    defaultOpen*/}
                    {/*                    header={t("trainings")}*/}
                    {/*                    children={*/}
                    {/*                        <div>*/}
                    {/*                            <Row*/}
                    {/*                                gutter={[16, 16]}*/}
                    {/*                                className="eq-section-training-filter"*/}
                    {/*                            >*/}
                    {/*                                <Col xs={24} md={8}>*/}
                    {/*                                    <EqSelect {...trainingTypeProps}></EqSelect>*/}
                    {/*                                </Col>*/}
                    {/*                                <Col xs={24} md={8}>*/}
                    {/*                                    <DatePicker*/}
                    {/*                                        placeholder={t("selectDate")}*/}
                    {/*                                        className="eq-filter-date eq-input-info"*/}
                    {/*                                        onChange={(date) => setFromDate(date)}*/}
                    {/*                                        value={*/}
                    {/*                                            fromDate && fromDate.isValid()*/}
                    {/*                                                ? fromDate*/}
                    {/*                                                : null*/}
                    {/*                                        }*/}
                    {/*                                    />*/}
                    {/*                                </Col>*/}
                    {/*                                <Col xs={24} md={8}>*/}
                    {/*                                    <EqButton classNames="btn-background-white btn-border-text-orange eq-filter-btn">*/}
                    {/*                                        <FontAwesomeIcon*/}
                    {/*                                            icon={faFilter}*/}
                    {/*                                            className="eq-filter-btn-icon"*/}
                    {/*                                        />*/}
                    {/*                                        {t("filter")}*/}
                    {/*                                    </EqButton>*/}
                    {/*                                </Col>*/}
                    {/*                            </Row>*/}
                    {/*                            <EqActivityTrainingStudentDashboard*/}
                    {/*                                trainingList={filterTrainings(joinedTrainings)}*/}
                    {/*                            ></EqActivityTrainingStudentDashboard>*/}
                    {/*                        </div>*/}
                    {/*                    }*/}
                    {/*                />*/}
                    {/*            </Col>*/}
                    {/*        )}*/}
                    {/*    </Row>*/}
                    {/*</div>*/}

                    {/* student Schedule */}
                    {/* <EqStudentSchedule
                        isOwner={false}
                        isStudent={true}
                        eventList={studentEventClasses}
                        trainings={trainings ?? []}
                        studentProductOrders={studentProductOrders}
                        courses={studentCourses}
                        horsesList={horsesList}
                    /> */}
                </div>
            </AnimationDiv>

            {/* make separate component for that */}
            {/* <Modal
                width={1000}
                title={t("unPaidOrders")}
                className="unpaid-Orders-modal"
                open={isModalVisible}
                onCancel={handleCancel}
                footer={null} // Custom footer
                closable={checkClosable()}
                maskClosable={true}
                // closeIcon={<span style={{ fontSize: '16px', color: '#000' }}>X</span>}
            >
                <>
                    <Tabs defaultActiveKey="1">
                    {
                    ((unpaidOrders?.unPaidCourseOrders && unpaidOrders?.unPaidCourseOrders?.length>0) || (unpaidOrders?.unPaidCourseLessonOrders && unpaidOrders?.unPaidCourseLessonOrders?.length>0)) &&(
                        <Tabs.TabPane tab={t("courseOrders")} key={"1"}>
                            <>
                                {unpaidOrders?.unPaidCourseOrders.map(
                                (item: CourseLessonOrderEnt, index: number) => (
                                    <div className="eq-activity-row">
                                        <Row className="eq-status-row-border" key={index}>
                                            <Col className="content-col">
                                                <Row>
                                                    <Col>
                                                        <div className="date-icon">
                                                            <EqIconCalendar
                                                                eqWidth={34}
                                                                eqHeight={34}
                                                                eqClass="eq-cal-icon"
                                                                eqFill="#083b49"
                                                            />
                                                            <div className="day">
                                                                {moment(
                                                                    item?.course?.startDate
                                                                ).format("DD")}
                                                            </div>
                                                            <div className="month">
                                                                {moment(
                                                                    item?.course?.startDate
                                                                ).format("MMM")}
                                                            </div>
                                                        </div>
                                                    </Col>

                                                    <Col className="header-details">
                                                        <Row>
                                                            <Col></Col>
                                                            <Col>
                                                                {" "}
                                                                <span className="time">
                                                                    {moment(
                                                                        item?.course?.startDate
                                                                    ).format("hh:mm A")}{" "}
                                                                </span>
                                                            </Col>
                                                            <Col className="price">
                                                                <EqIconPrice
                                                                    eqWidth="15"
                                                                    eqHeight="13"
                                                                    eqFill="#b5b5b5"
                                                                />{" "}
                                                                {item.customPrice
                                                                    ? item.customPrice
                                                                    : item.course?.coursePrice}
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="eq-f-th">
                                                                {item?.course?.title}
                                                            </Col>
                                                           
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Col>

                                            <Col className="action-col">
                                                <EqButton
                                                    onClick={() =>
                                                        GetCourseOrderCheckoutSession(item.id)
                                                    }
                                                >
                                                    {t("payNow")}
                                                </EqButton>
                                            </Col>
                                        </Row>
                                    </div>
                                )
                            )}
                             {unpaidOrders?.unPaidCourseLessonOrders.map(
                                (item: CourseLessonOrderEnt, index: number) => (
                                    <div className="eq-activity-row">
                                        <Row className="eq-status-row-border" key={index}>
                                            <Col className="content-col">
                                                <Row>
                                                    <Col>
                                                        <div className="date-icon">
                                                            <EqIconCalendar
                                                                eqWidth={34}
                                                                eqHeight={34}
                                                                eqClass="eq-cal-icon"
                                                                eqFill="#083b49"
                                                            />
                                                            <div className="day">
                                                                {moment(
                                                                    item?.courseLesson?.startTime
                                                                ).format("DD")}
                                                            </div>
                                                            <div className="month">
                                                                {moment(
                                                                    item?.courseLesson?.startTime
                                                                ).format("MMM")}
                                                            </div>
                                                        </div>
                                                    </Col>

                                                    <Col className="header-details">
                                                        <Row>
                                                            <Col></Col>
                                                            <Col>
                                                                {" "}
                                                                <span className="time">
                                                                    {moment(
                                                                        item?.courseLesson?.startTime
                                                                    ).format("hh:mm A")}{" "}
                                                                </span>
                                                            </Col>
                                                            <Col>
                                                            <EtTag>
                                                                {CourseOrderType[item?.orderType]}
                                                            </EtTag>
                                                            </Col>
                                                            <Col className="price">
                                                                <EqIconPrice
                                                                    eqWidth="15"
                                                                    eqHeight="13"
                                                                    eqFill="#b5b5b5"
                                                                />{" "}
                                                                {item.customPrice
                                                                    ? item.customPrice
                                                                    : item.courseLesson?.price}
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="eq-f-th">
                                                                {item?.courseLesson?.course?.title}
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Col>

                                            <Col className="action-col">
                                                <EqButton
                                                    onClick={() =>
                                                        GetCourseLessonOrderCheckoutSession(item.id)
                                                    }
                                                >
                                                    {t("payNow")}
                                                </EqButton>
                                            </Col>
                                        </Row>
                                    </div>
                                )
                            )}
                            
                            </>
                        </Tabs.TabPane>

                    )}
                        {unpaidOrders?.unPaidTrainingOrders && unpaidOrders?.unPaidTrainingOrders.length>0 &&(
  <Tabs.TabPane tab={t("trainingOrders")} key={"2"}>
  {unpaidOrders?.unPaidTrainingOrders.map(
      (item: EqEntityEventUserGroup, index: number) => (
          <div className="eq-activity-row">
              <Row className="eq-status-row-border" key={index}>
                  <Col className="content-col">
                      <Row>
                          <Col>
                              <div className="date-icon">
                                  <EqIconCalendar
                                      eqWidth={34}
                                      eqHeight={34}
                                      eqClass="eq-cal-icon"
                                      eqFill="#083b49"
                                  />
                                  <div className="day">
                                      {moment(
                                          item.event.startDate
                                      ).format("DD")}
                                  </div>
                                  <div className="month">
                                      {moment(
                                          item.event.startDate
                                      ).format("MMM")}
                                  </div>
                              </div>
                          </Col>
                          <Col className="header-details">
                              <Row>
                                  <Col></Col>
                                  <Col>
                                      {" "}
                                      <span className="time">
                                          {moment(
                                              item.event.startTime
                                          ).format("hh:mm A")}{" "}
                                      </span>
                                  </Col>
                                  <Col className="price">
                                      <EqIconPrice
                                          eqWidth="15"
                                          eqHeight="13"
                                          eqFill="#b5b5b5"
                                      />{" "}
                                      {item.event?.price}
                                  </Col>
                                  
                              </Row>
                              <Row>
                                  <Col className="title">
                                      {item?.event?.title}
                                  </Col>
                              </Row>
                          </Col>
                      </Row>
                  </Col>

                  <Col className="action-col">
                      <EqButton
                          onClick={() =>
                              CreateTrainingLessonOrderCheckoutSession(
                                  item.event
                              )
                          }
                      >
                          {t("payNow")}
                      </EqButton>
                  </Col>
              </Row>
          </div>
      )
  )}
</Tabs.TabPane>
                        )}
                      
                    </Tabs>
                </>
        </Modal> */}

            <UnPaidOrdersModalStudent
                isModalVisible={isModalVisible}
                handleCancel={handleCancel}
                checkClosable={checkClosable}
                unpaidOrders={unpaidOrders}
                GetCourseOrderCheckoutSession={GetCourseOrderCheckoutSession}
                GetCourseLessonOrderCheckoutSession={GetCourseLessonOrderCheckoutSession}
                CreateTrainingLessonOrderCheckoutSession={CreateTrainingLessonOrderCheckoutSession}
            />
        </Spin>
    );
};
export default EqStudentDashboard;
